import PropTypes from "prop-types";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import ResourceFilename from "./ResourceFilename";

export const plainLessonDescription = (value) => {
  if (typeof value !== "string" || !value.trim()) return "";
  const parsed = new DOMParser().parseFromString(value, "text/html");
  parsed.querySelectorAll("script,style,iframe,object").forEach((node) => node.remove());
  parsed.querySelectorAll("br").forEach((node) => node.replaceWith("\n"));
  parsed.querySelectorAll("p,div,li,h1,h2,h3,h4,h5,h6").forEach((node) => node.append("\n"));
  return (parsed.body.textContent || "").replace(/\n{3,}/g, "\n\n").trim();
};

const LessonResources = ({ chapter, language, onDownload, downloadingFileId }) => {
  const { t } = useTranslation();
  const rawDescription = chapter?.desc?.[language] || chapter?.desc?.en || chapter?.desc?.pr || chapter?.desc?.ps || "";
  const description = plainLessonDescription(rawDescription);
  const files = chapter?.files || [];

  if (!description && files.length === 0) return null;

  return (
    <>
      {description && (
        <div className="pt-2 mt-3 whitespace-pre-wrap text-base text-gray-800 dark:text-gray-100 lg:text-lg">
          {description}
        </div>
      )}
      {files.length > 0 && (
        <section className="mt-4 rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900/40">
          <h3 className="text-base font-bold text-gray-900 dark:text-white">{t("Lesson-resources", { defaultValue: "Lesson files" })}</h3>
          <div className="mt-3 space-y-2">
            {files.map((file) => {
              const filename = file.originalName || file.title || "";
              return (
                <div key={file._id} className="flex min-w-0 flex-col gap-2 rounded-xl border border-gray-200 p-3 dark:border-gray-700 sm:flex-row sm:items-center sm:justify-between">
                  <div className="min-w-0 max-w-full sm:flex-1">
                    <ResourceFilename name={file.title || filename} originalName={filename} className="text-sm text-gray-800 dark:text-gray-100" />
                  </div>
                  <button type="button" onClick={() => onDownload(file, chapter._id)} disabled={downloadingFileId === file._id} className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-60">
                    <FiDownload aria-hidden="true" />{t("Download-resource", { defaultValue: "Download" })}
                  </button>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};

LessonResources.propTypes = {
  chapter: PropTypes.object,
  language: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
  downloadingFileId: PropTypes.string,
};

export default LessonResources;
